// @ts-nocheck
const Events = {
  Loaded: 'concord-loaded',
  LoadedConfig: 'concord-config-ready',
  Ready: 'concord-ready',
  Unavailable: 'concord-unavailable',
  ConsentStateChanged: 'concord-consent-state-changed',
  ConsentStateLoading: 'concord-consent-state-loading',
  ConsentStateLoaded: 'concord-consent-state-loaded',
  ConsentTypesChanged: 'concord-consent-types-changed',
  ConsentTypesLoading: 'concord-consent-types-loading',
  ConsentTypesLoaded: 'concord-consent-types-loaded',
  ComplianceRequestsChanged: 'concord-compliance-requests-changed',
  ComplianceRequestsLoading: 'concord-compliance-requests-loading',
  ComplianceRequestsLoaded: 'concord-compliance-requests-loaded',
};

export default Events;
